import { Component, OnInit, ViewChild } from '@angular/core';
import { DsModalComponent } from 'design-system';
import { Subscription } from 'rxjs';
import { ErrorHandlerService } from 'src/app/services/error-handler/error-handler.service';

@Component({
  selector: 'app-http-error-modal',
  templateUrl: './http-error-modal.component.html',
  styleUrls: ['./http-error-modal.component.scss']
})
export class HttpErrorModalComponent implements OnInit {

  errorHandlerSubscripition: Subscription;
  showAdmin: boolean = true;
  title = '';
  errorMessage = '';

  @ViewChild('errorModal') errorModal: DsModalComponent;

  constructor(
    private errorHandlerService: ErrorHandlerService,
  ) { }

  ngOnInit(): void {
    this.subscribeErrorHandler();
  }

  ngOnDestroy() {
    this.errorHandlerSubscripition.unsubscribe();
  }

  closeModal() {
    this.errorModal.disableModal();
  }

  private subscribeErrorHandler() {
    this.errorHandlerSubscripition = this.errorHandlerService.errorObservable
    .subscribe(error => {
      const errorObj = error.httpErrorResponse.error;
       if (errorObj?.code == 'api_request_error_newsletter' && errorObj?.reason?.opis) {
        this.showAdmin = false;
        this.title = errorObj.reason.komunikat;
        this.errorMessage = errorObj.reason.opis;
        this.errorModal.enableModal();
      } else {
        this.showAdmin = true;
        this.title = 'Wystąpił błąd w komunikacji z modułami PRS';
        this.errorMessage = `${error?.httpErrorResponse.message}<br>${errorObj?.reason || ''}`;
        this.errorModal.enableModal();
      }
    });
  }
}
